import { render } from "./Client.vue?vue&type=template&id=1f039eb2"
import script from "./Client.vue?vue&type=script&lang=js"
export * from "./Client.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__